module.exports = __webpack_public_path__ + "img/orange_066.d5eea822.png";